import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/style_legal_pages.css";
import {formatPhoneFR} from "../utils/validators";
import { useGlobalProperty } from "../context/GlobalPropertyContext";

export default function PolitiqueConfidentialite() {
  const navigate = useNavigate();
  const { globalProperties, loading: globalLoading } = useGlobalProperty();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back-btn" onClick={() => navigate(-1)}><ion-icon name="arrow-back-outline"></ion-icon>Retour</button>

        <header className="legal-header">
          <h1>Politique de Confidentialité</h1>
          <p className="legal-subtitle">Votre vie privée est notre priorité</p>
        </header>

        <article className="legal-content">
          
          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} attache une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos données.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Données Collectées</h2>
            <p>
              Nous collectons les données suivantes lorsque vous :
            </p>
            <ul>
              <li><strong>Créez un compte :</strong> nom, prénom, adresse email, mot de passe, adresse postale, numéro de téléphone</li>
              <li><strong>Effectuez un achat :</strong> informations de paiement, adresse de livraison, historique des commandes</li>
              <li><strong>Naviguez sur le site :</strong> adresse IP, type de navigateur, pages visitées, données de cookies</li>
              <li><strong>Nous contactez :</strong> contenu de vos messages, adresse email, numéro de téléphone</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Utilisation de Vos Données</h2>
            <p>
              Vos données personnelles sont utilisées pour :
            </p>
            <ul>
              <li>Traiter et gérer vos commandes</li>
              <li>Envoyer des confirmations et des mises à jour de commande</li>
              <li>Répondre à vos questions et demandes de support</li>
              <li>Améliorer notre site web et nos services</li>
              <li>Envoyer des newsletters et des communications marketing (avec votre consentement)</li>
              <li>Respecter les obligations légales</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Partage de Vos Données</h2>
            <p>
              Nous ne partageons vos données personnelles avec des tiers que dans les cas suivants :
            </p>
            <ul>
              <li><strong>Prestataires de service :</strong> partenaires logistiques, processeurs de paiement</li>
              <li><strong>Obligations légales :</strong> lorsque la loi l'exige</li>
              <li><strong>Protection des droits :</strong> en cas de litige ou de fraude</li>
            </ul>
            <p>
              Nous ne vendons jamais vos données à des tiers à des fins commerciales.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Sécurité de Vos Données</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} met en place des mesures de sécurité appropriées pour protéger vos données personnelles contre :
            </p>
            <ul>
              <li>L'accès non autorisé</li>
              <li>La modification non autorisée</li>
              <li>La divulgation non autorisée</li>
              <li>La destruction accidentelle</li>
            </ul>
            <p>
              Nous utilisons le chiffrement SSL pour sécuriser les transactions en ligne et les données de paiement.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Cookies</h2>
            <p>
              Notre site utilise des cookies pour :
            </p>
            <ul>
              <li>Mémoriser vos préférences</li>
              <li>Analyser l'utilisation du site</li>
              <li>Améliorer votre expérience utilisateur</li>
            </ul>
            <p>
              Vous pouvez configurer votre navigateur pour refuser les cookies. Cependant, cela peut affecter votre expérience sur le site.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Vos Droits</h2>
            <p>
              En vertu de la loi RGPD, vous avez les droits suivants :
            </p>
            <ul>
              <li><strong>Droit d'accès :</strong> accéder à vos données personnelles</li>
              <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
              <li><strong>Droit à l'oubli :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
            </ul>
            <p>
              Pour exercer ces droits, contactez-nous à : contact@latelierfloral.fr
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Conservation de Vos Données</h2>
            <p>
              Nous conservons vos données personnelles aussi longtemps que nécessaire pour :
            </p>
            <ul>
              <li>Vous fournir nos services</li>
              <li>Respecter les obligations légales</li>
              <li>Résoudre les litiges</li>
            </ul>
            <p>
              Une fois ces périodes expirées, vos données sont supprimées de manière sécurisée.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact du Responsable de la Protection des Données</h2>
            <p>
              Si vous avez des questions concernant cette politique de confidentialité ou si vous souhaitez exercer vos droits RGPD, veuillez nous contacter :
            </p>
            <p>
              {globalProperties?.contacte?.email !== "" && <><strong>Email : </strong>{globalProperties?.contacte?.email || ""}<br /></>}
              {globalProperties?.contacte?.phone !== "" && <><strong>Téléphone : </strong>{formatPhoneFR(globalProperties?.contacte?.phone || "")}<br /></>}
              {globalProperties?.address?.street !== "" && globalProperties?.address?.postal_code !== "" && globalProperties?.address?.city !== "" && globalProperties?.address?.country !== "" && <>
                <strong>Adresse : </strong>{
                  (globalProperties?.address?.street || "") + ", " + 
                  (globalProperties?.address?.postal_code || "") + ", " + 
                  (globalProperties?.address?.city || "") + ", " + 
                  (globalProperties?.address?.country || "")}<br />
              </>}
            </p>
          </section>

          <section className="legal-section last">
            <h2>10. Modifications de cette Politique</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} se réserve le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page et prendront effet immédiatement.
            </p>
            <p className="legal-date">
              <em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</em>
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}